import { __awaiter, __generator } from "tslib";
import { merge } from 'lodash';
import { searchAppSettings, } from '@wix/search-results-settings-definitions';
var defaultCatetoryList = searchAppSettings.categoryList.getDefaultValue();
var api = '/_api/app-settings-service/v1/settings/instances';
export var createSettingsClient = function (_a) {
    var instance = _a.instance, _b = _a.host, host = _b === void 0 ? '' : _b, reportError = _a.reportError;
    var headers = {
        'Content-Type': 'application/json',
        Authorization: instance,
    };
    var getDefault = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, Promise.resolve({ categoryList: defaultCatetoryList })];
        });
    }); };
    var get = function (state) { return __awaiter(void 0, void 0, void 0, function () {
        var response, data, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, fetch("" + host + api + "?state=" + state + "&host=VIEWER", {
                            cache: 'no-cache',
                            headers: headers,
                        })];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    data = _a.sent();
                    return [2 /*return*/, merge({}, { categoryList: defaultCatetoryList }, data.settings)];
                case 3:
                    e_1 = _a.sent();
                    return [2 /*return*/, getDefault()];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var set = function (key, value) { return __awaiter(void 0, void 0, void 0, function () {
        var e_2;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, fetch("" + host + api, {
                            method: 'PATCH',
                            cache: 'no-cache',
                            headers: headers,
                            body: JSON.stringify({
                                settings: (_a = {}, _a[key] = value, _a),
                                host: 'VIEWER',
                                states: ['SAVED'],
                            }),
                        })];
                case 1:
                    _b.sent();
                    return [2 /*return*/];
                case 2:
                    e_2 = _b.sent();
                    console.error(e_2);
                    reportError(e_2);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return {
        getSaved: function () { return get('SAVED'); },
        getPublished: function () { return get('PUBLISHED'); },
        getDefault: getDefault,
        set: set,
    };
};
//# sourceMappingURL=settingsClient.js.map